import { Trans } from "@lingui/react/macro";
import { type ReactNode, useId } from "react";

import { SELLER } from "../../lib/seller";
import { useSellerName } from "../../lib/useSellerName";

const linkClassName = "text-accent hover:text-accent-strong";

// Реквизиты исполнителя в конце документа: ИП, ИНН, ОГРНИП, регион, почта и поддержка.
export const SellerCard = ({ title }: { title: ReactNode }) => {
  const headingId = useId();
  const seller = useSellerName();
  return (
    <section
      aria-labelledby={headingId}
      className="flex flex-col gap-2 rounded-xl border border-border bg-surface px-5 py-4"
    >
      <h2 id={headingId} className="font-display text-[26px] leading-tight text-foreground">
        {title}
      </h2>
      <dl className="grid grid-cols-[max-content_minmax(0,1fr)] gap-x-4 gap-y-1">
        <dt className="text-subtle">
          <Trans>Provider</Trans>
        </dt>
        <dd>{seller}</dd>
        <dt className="text-subtle">
          <Trans>TIN</Trans>
        </dt>
        <dd className="font-mono">{SELLER.inn}</dd>
        <dt className="text-subtle">
          <Trans>OGRNIP</Trans>
        </dt>
        <dd className="font-mono">{SELLER.ogrnip}</dd>
        <dt className="text-subtle">
          <Trans>Region</Trans>
        </dt>
        <dd>
          <Trans>Leningrad Oblast</Trans>
        </dd>
        <dt className="text-subtle">
          <Trans>Email</Trans>
        </dt>
        <dd>
          <a href={`mailto:${SELLER.email}`} className={linkClassName}>
            {SELLER.email}
          </a>
        </dd>
        <dt className="text-subtle">
          <Trans>Support</Trans>
        </dt>
        <dd>
          <a href={SELLER.supportUrl} className={linkClassName}>
            {SELLER.supportUrl.replace("https://", "")}
          </a>
        </dd>
      </dl>
    </section>
  );
};
